import {useCallback, useState} from 'react';
import {useProductZoomOpenedState} from '../utils';
import {ProductImageDetailsModalViewProps} from './ProductImageDetailsModalView';

interface DialogState extends ProductImageDetailsModalViewProps {
  open: (index: number) => void;
}

export const useProductImageDetailsModalState = (): DialogState => {
  const {cancel, isOpen, open: openZoom} = useProductZoomOpenedState();
  const [currentIndex, setOpenIndex] = useState<number>(0);
  const open = useCallback(
    (index: number) => {
      setOpenIndex(index);
      openZoom();
    },
    [setOpenIndex, openZoom],
  );
  return {
    isOpen,
    currentIndex,
    open,
    onClose: cancel,
  };
};
